import React from 'react';
import Moment from 'react-moment';
import classNames from 'classnames';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { sellerProfilesSelectors } from 'Douleutaras/redux/data/seller/sellerProfilesSlice';
import { useTranslation } from 'react-i18next';
import { usersSelector } from 'Douleutaras/redux/data/users/usersSlice';
import { sellerReviewsResponseSelectors } from 'Douleutaras/redux/data/seller/sellerReviewsResponseSlice';
import LineClamp from 'Douleutaras/components/LineClamp/LineClamp';
import { useLocalization } from 'Douleutaras/hooks/localization';

import './ReviewCard.scss';

export const ReplyInfo = ({ id, username }) => {
  if (!id) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  const { t } = useTranslation();
  const profile = useAppSelector(state => sellerProfilesSelectors.selectByUsername(state, username));
  const reply = useAppSelector(state => sellerReviewsResponseSelectors.selectById(state, id));

  if (!reply) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  return (
    <div styleName="review-reply">
      <span styleName="review-reply__icon" className="dashicon dashicon-reply-arrow" />
      <div styleName="review-reply__content">
        <div styleName="review-reply__info">
          <div styleName="review-reply__name">{profile?.attributes.sellerDisplayName}</div>
          <div styleName="review-reply__date">
            <Moment format="DD/MM/YY">
              {reply.attributes.created}
            </Moment>
          </div>
        </div>
        <div styleName="review-reply__text">
          <LineClamp
            maxChars={150}
            moreText={t('T.PROS-PROFILE.ABOUT.SHOW-MORE')}
            lessText={t('T.PROS-PROFILE.ABOUT.SHOW-LESS')}
            offsetToleranceChars={20}
          >
          {reply.attributes.comment}
          </LineClamp>
        </div>
      </div>
    </div>
  );
};

export const ReviewCard = ({review, username, pinned = false}) => {
  const { t } = useTranslation();
  const { formatter } = useLocalization();

  const buyerId = review.relationships.client?.data?.id || review.relationships.buyer?.data?.id;
  const user = useAppSelector(state => usersSelector.selectById(state, buyerId));

  // tslint:disable-next-line:no-shadowed-variable
  const BuyerName = user => {
    if (!user || !user.attributes) {

      // tslint:disable-next-line:no-null-keyword
      return null;
    }

    if (user.type === 'externalClient') {
      return `${user.attributes.firstName} ${user.attributes.lastName[0]}.`;
    } else if (user.attributes.sellerDisplayName) {

      const names = user.attributes.sellerDisplayName.split(' ');

      return names.length >= 2
        ? `${names[0]} ${names[1].charAt(0)
          .toUpperCase()}.`
        : user.attributes.sellerDisplayName;
    }
  };

  return (
    <>
      <div styleName={classNames('review-card', { 'review-card--pinned': pinned })}>
        {pinned &&
          <div styleName="review-card__pinned-label">
            <span styleName="review-card__pinned-icon" className="dashicon dashicon-gratitude" />
            <span>{t('T.PROS-PROFILE.REVIEW.PINNED-REVIEW')}</span>
          </div>
        }
        <div styleName="review-rating">
          <span styleName="review-start" className="dashicon dashicon-star" />
          <div styleName="review-value">{formatter.number(review?.attributes.rating)}</div>
          <div styleName="review-info">
            <div styleName="review-name">
              {BuyerName(user)}
            </div>
            <div styleName="review-day">
              <Moment format="DD/MM/YY">
                {review?.attributes.created}
              </Moment>
            </div>
          </div>
        </div>
        {Boolean(review?.attributes.comment) &&
          <div styleName="review-text">
            <LineClamp
              maxChars={150}
              moreText={t('T.PROS-PROFILE.ABOUT.SHOW-MORE')}
              lessText={t('T.PROS-PROFILE.ABOUT.SHOW-LESS')}
              offsetToleranceChars={20}
            >
              {review?.attributes.comment}
            </LineClamp>
          </div>
        }
        {review?.relationships.response?.data !== null &&
          <ReplyInfo id={review?.relationships.response.data.id} username={username} />
        }
      </div>
    </>
  );
};
